const deprecateRenamedProperty = (
  componentName,
  oldProperty,
  newProperty,
  value
) => {
  if (value) {
    if (process.env.NODE_ENV === "development") {
      console.warn(
        `${componentName} property ${oldProperty} is deprecated. Please use ${newProperty} instead.`
      );
    }
    return value;
  }
};

export default deprecateRenamedProperty;
